import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Download } from 'lucide-react';
import toast from 'react-hot-toast';

const productLinks = [
  { label: 'Profiles', path: '/profiles' },
  { label: 'Stories', path: '/stories' },
  { label: 'Wizard', path: '/profiles/create' },
];

const companyLinks = [
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' },
  { label: 'Privacy', path: '/privacy' },
  { label: 'Terms & Conditions', path: '/terms' },
];

const supportLinks = [
  { label: 'Help Center', path: '/help' },
  { label: 'Roadmap', path: '/roadmap' },
  { label: 'Feedback', path: '/feedback' },
];

const Footer = () => {
  const navigate = useNavigate();

  const handleInstallClick = () => {
    toast(
      "To install the app, open your browser's menu and choose “Install app” or “Add to Home Screen”.",
      {
        icon: '📲',
      }
    );
  };

  const renderLinkGroup = (title, links) => (
    <div>
      <h4 className="font-semibold mb-3">{title}</h4>
      <ul className="space-y-2 text-sm text-purple-200">
        {links.map((link) => (
          <li key={link.label}>
            <button
              type="button"
              onClick={() => navigate(link.path)}
              className="hover:text-white transition-colors"
            >
              {link.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <footer className="bg-gradient-to-r from-purple-900 via-purple-800 to-pink-900 text-white mt-16">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-5 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <span className="text-2xl font-black tracking-tight leading-none">
                <span className="text-[#ff405c]">my</span>
                <span className="text-white">STORY</span>
                <span className="text-[#ff405c]">me</span>
              </span>
            </div>
            <p className="text-purple-200 text-sm mb-4">
              Magical, personalized stories that turn every child into the hero of their own adventure.
            </p>
            <button
              type="button"
              onClick={() => navigate('/profiles/create')}
              className="inline-flex items-center px-4 py-2 bg-white/10 hover:bg-white/20 rounded-lg text-sm font-semibold transition-colors"
            >
              Start Creating
            </button>
          </div>

          {renderLinkGroup('Product', productLinks)}
          {renderLinkGroup('Company', companyLinks)}
          {renderLinkGroup('Support', supportLinks)}

          <div className="md:col-span-1 text-sm text-purple-200">
            <button
              type="button"
              onClick={handleInstallClick}
              className="inline-flex items-center px-4 py-2 bg-purple-700 hover:bg-purple-600 rounded-lg text-white font-semibold transition-colors"
            >
              <Download className="h-4 w-4 mr-2" />
              Install App
            </button>
          </div>
        </div>
        <div className="border-t border-white/10 mt-8 pt-6 text-center text-purple-200 text-sm">
          <p>&copy; {new Date().getFullYear()} mySTORYme. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

